import { createSelector } from 'reselect';
import { isNull, omitBy, pick } from 'lodash/fp';
import { PRODUCT_TYPE, RELATIONSHIP } from '@ahmdigital/constants';

import { INCOME_TIER_NONE } from '../../constants';
import getMemberAge from '../../../../utils/get-member-age';
import selectCustomer from '../../../../selectors/select-customer';

export default createSelector(selectCustomer, (customer) =>
  omitBy(isNull, {
    ...pick(
      ['frequency', 'hospitalExcess', 'incomeTier', 'incomeType', 'productType', 'rebate', 'scale', 'state'],
      customer,
    ),
    age: getMemberAge({ customer, relationship: RELATIONSHIP.CLIENT }) || '',
    incomeTier: customer.rebate === false ? INCOME_TIER_NONE : customer.incomeTier,
    partnerAge: getMemberAge({ customer, relationship: RELATIONSHIP.SPOUSE }) || '',
    productType: customer.productType === PRODUCT_TYPE.COMBINED ? PRODUCT_TYPE.PACKAGE : customer.productType,
  }),
);
